module.exports = __webpack_public_path__ + "img/map_suite-locations_party.a0110bd0.svg";